import {
  DisplayContractorsPlannedHoursWizardResult,
  ReadContractorsPlannedHoursWizardResult,
} from "@/types/contractorsPlannedHoursWizard";

export function mapApiResultsToPeriodRows(
  results: ReadContractorsPlannedHoursWizardResult[],
): DisplayContractorsPlannedHoursWizardResult[] {
  return results.map((row, index) => ({
    id: `${index}-${row.period}`,
    period: row.period,
    hours: row.hours,
  }));
}
